(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var heroOfferTimers = new WeakMap();

    function pad(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }

    function parseTargetDate(value) {
      if (!value) return null;

      var cleaned = value.trim().replace(/\//g, '-');

      var match = cleaned.match(
        /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/
      );

      if (match) {
        return new Date(
          Number(match[1]),
          Number(match[2]) - 1,
          Number(match[3]),
          match[4] ? Number(match[4]) : 23,
          match[5] ? Number(match[5]) : 59,
          match[6] ? Number(match[6]) : 59
        );
      }

      var parsed = new Date(cleaned);
      if (Number.isNaN(parsed.getTime())) return null;
      return parsed;
    }

    function setValue(root, unit, value) {
      var el = root.querySelector('[data-unit="' + unit + '"]');
      if (el) el.textContent = pad(value);
    }

    function setZeros(root) {
      setValue(root, 'days', 0);
      setValue(root, 'hours', 0);
      setValue(root, 'minutes', 0);
      setValue(root, 'seconds', 0);
    }

    function collectRoots(scope) {
      if (!scope) return [];
      if (scope.nodeType === 1 && scope.hasAttribute('data-hero-offer')) return [scope];
      if (!scope.querySelectorAll) return [];
      return scope.querySelectorAll('[data-hero-offer]');
    }

    function mount(root) {
      if (!root) return;

      if (heroOfferTimers.has(root)) {
        clearInterval(heroOfferTimers.get(root));
        heroOfferTimers.delete(root);
      }

      function tick() {
        var targetDate = parseTargetDate(root.dataset.targetDate);

        if (!targetDate) {
          setZeros(root);
          root.setAttribute('data-invalid-date', 'true');
          return;
        }

        root.removeAttribute('data-invalid-date');

        var now = new Date().getTime();
        var distance = targetDate.getTime() - now;

        if (distance <= 0) {
          setZeros(root);

          if (heroOfferTimers.has(root)) {
            clearInterval(heroOfferTimers.get(root));
            heroOfferTimers.delete(root);
          }

          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        setValue(root, 'days', days);
        setValue(root, 'hours', hours);
        setValue(root, 'minutes', minutes);
        setValue(root, 'seconds', seconds);
      }

      tick();
      var timer = setInterval(tick, 1000);
      heroOfferTimers.set(root, timer);
    }

    function init(scope) {
      var roots = collectRoots(scope);
      Array.prototype.forEach.call(roots, mount);
    }

    function destroy(scope) {
      var roots = collectRoots(scope);
      Array.prototype.forEach.call(roots, function (root) {
        if (heroOfferTimers.has(root)) {
          clearInterval(heroOfferTimers.get(root));
          heroOfferTimers.delete(root);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroy(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.InfoBarRotator) {
      window.InfoBarRotator = {
        timers: new WeakMap(),

        init: function (root) {
          if (!root) return;

          var items = root.querySelectorAll('[data-carousel-item]');
          if (!items.length) return;

          this.destroy(root);

          var index = 0;
          var delay = parseInt(root.getAttribute('data-rotate-ms'), 10);

          if (!delay || delay < 1000) delay = 20000;

          function showItem(activeIndex) {
            Array.prototype.forEach.call(items, function (item, itemIndex) {
              item.classList.toggle('is-active', itemIndex === activeIndex);
            });
          }

          showItem(index);

          if (items.length === 1) return;

          var timer = setInterval(function () {
            index = (index + 1) % items.length;
            showItem(index);
          }, delay);

          this.timers.set(root, timer);
        },

        destroy: function (root) {
          var existingTimer = this.timers.get(root);
          if (existingTimer) {
            clearInterval(existingTimer);
            this.timers.delete(root);
          }
        },

        initAll: function (scope) {
          var roots = (scope || document).querySelectorAll('[data-info-bar]');
          Array.prototype.forEach.call(roots, function (root) {
            window.InfoBarRotator.init(root);
          });
        },

        destroyAll: function (scope) {
          var roots = (scope || document).querySelectorAll('[data-info-bar]');
          Array.prototype.forEach.call(roots, function (root) {
            window.InfoBarRotator.destroy(root);
          });
        }
      };
    }

    function startInfoBars() {
      window.InfoBarRotator.initAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startInfoBars);
    } else {
      startInfoBars();
    }

    if (!window.__infoBarRotatorEventsBound) {
      window.__infoBarRotatorEventsBound = true;

      document.addEventListener('shopify:section:load', function (event) {
        window.InfoBarRotator.initAll(event.target);
      });

      document.addEventListener('shopify:section:unload', function (event) {
        window.InfoBarRotator.destroyAll(event.target);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
